/**
 * utils/serviceWorker.js — регистрация SW строго после логина.
 *
 * ⚠️ SW (вместе с манифестом) — то, что делает сайт «устанавливаемым»: именно
 * его наличие браузер проверяет перед тем, как предложить «Добавить на экран».
 * Раньше регистрация стояла в index.js безусловно на КАЖДОЙ странице — человек
 * получал предложение установить приложение уже на экране регистрации, когда
 * у тенанта ещё нет лого и не на что ставить иконку. Регистрируем только
 * из авторизованного приложения (см. App.js) — до этого момента и сама
 * установка не имеет смысла.
 *
 * Дев — отдельная ветка в index.js (там SW наоборот снимается), сюда не заходит.
 */
export function registerServiceWorker() {
  if (process.env.NODE_ENV !== 'production') return;
  if (!('serviceWorker' in navigator)) return;

  navigator.serviceWorker.register('/sw.js')
    .then(reg => {
      console.log('[SW] Зарегистрирован, scope:', reg.scope);
    })
    .catch(err => {
      console.warn('[SW] Ошибка регистрации:', err);
    });
}
